<!--
 * @Description: 经纪人选择
 * @Author: lijinpeng
 * @Date: 2022-04-09 14:58:05
 * @LastEditors: lijinpeng
-->
<template>
  <div class="nf-settle">
    <el-row>
      <el-col :span="8">
        <el-select
          v-model="value"
          placeholder="请选择运费支付方式"
          size="small"
          :disabled="disabled"
          @change="handleSelectMethod"
        >
          <el-option
            v-for="item in settleMethodList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
            :disabled="item.disabled"
          />
        </el-select>
      </el-col>
      <el-col v-if="value === 2" :span="15" style="margin-left: 10px">
        <el-select
          v-if="value === 2"
          size="small"
          :value="payeeName"
          popper-class="nf-settle-captain"
          placeholder="输入经纪人姓名"
          no-match-text="无匹配经纪人"
          :disabled="disabled"
          @change="handleSelectSettle"
          @visible-change="handleCaptainVisible"
          filterable
          :filter-method="handleCaptainRemoteMethod"
          :loading="isLoading"
        >
          <el-option class="flexCon justify_end" value="createSettle">
            <el-button type="text" style="width: 100%">
              <span style="float: right">+创建经纪人</span>
            </el-button>
          </el-option>
          <el-option v-for="item in settleList" :key="item.id" :value="item.id">
            <div class="nf-settle-captain-option">
              <p class="nf-settle-captain-option_info">
                <span class="margin-r-5">{{ item.payeeName }}</span>
                <span class="margin-r-5">{{ item.reserveMobileNo }}</span>
                <span class="icon-default" v-if="item.isDefault === 1">默认</span>
              </p>
              <p class="nf-settle-captain-option_bankName ellipsis">
                {{ item.bankName || item.subBankName }}
              </p>
              <p class="nf-settle-captain-option_payeeBankCardNo">
                {{ item.payeeBankCardNo | filterBankCardNo }}
              </p>
            </div>
          </el-option>
        </el-select>
      </el-col>

      <el-col
        v-if="value === 1 && settleInfo.waybillNo && driverInfo.bankCardPhone"
        :span="15"
        style="margin-left: 10px"
      >
        <div class="nf-settle-captain">
          <div class="nf-settle-captain-option nf-settle-captain-option-driver">
            <p class="nf-settle-captain-option_info">
              <span class="margin-r-5">{{ driverInfo.name }}</span>
              <span class="margin-r-5">{{ driverInfo.bankCardPhone }}</span>
            </p>
            <p class="nf-settle-captain-option_bankName nf-settle-captain-driver ellipsis">
              {{ driverInfo.supBank }} {{ driverInfo.bankCard }}
            </p>
          </div>
        </div>
      </el-col>
    </el-row>
    <Captain
      v-if="showCaptain"
      :show.sync="showCaptain"
      :info="info"
      title="创建收款信息"
      @handleClose="showCaptain = false"
      @handleSubmit="showCaptain = false"
    />
  </div>
</template>
<script>
import { getCollectPageList, getWaybillDriverBank } from '@/api/captain';
import Captain from '@/views/capacity/payee/components/captain/index.vue';
import { logReport } from '@/api/data';

export default {
  name: 'NfSettleSelect',
  components: { Captain },

  props: {
    value: [String, Number],
    settleInfo: {
      // 经纪人信息
      type: Object,
      default: () => {
        return {};
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isLoading: false,
      showCaptain: false,
      payeeName: '', // 收款人姓名
      settleList: [], // 经纪人列表
      driverInfo: {}, // 司机信息
      selectSettle: {}, // 当前选中的经纪人
      settleMethodList: [
        {
          value: 1,
          label: '司机',
        },
        {
          value: 2,
          label: '经纪人',
          disabled: true,
        },
      ],
      info: {
        bankCardNo: '',
        payeeName: '',
        payeeIdentityNo: '',
        identityFrontFace: '',
        identityBackFace: '',
        payeeBankCardNo: '',
        bankName: '',
        bankShortName: '',
        reserveMobileNo: '',
        bankProvince: '',
        bankCity: '',
        payeeType: '',
        isDefault: '',
        isDelete: '',
        date: [],
      },
    };
  },
  created() {
    if (this.value === 1 && this.settleInfo.waybillNo) {
      this.getDriverByBill();
    }
    if (this.settleInfo && this.settleInfo.captainName && this.settleInfo.captainBankNo) {
      this.getPayeeName({
        payeeName: this.settleInfo.captainName,
        payeeBankCardNo: this.settleInfo.captainBankNo,
      });
    }
  },
  watch: {
    settleInfo: {
      handler(val) {
        if (val && val.captainName) {
          this.getPayeeName({
            payeeName: val.captainName,
            payeeBankCardNo: val.captainBankNo,
          });
        }
      },
      deep: true,
    },
  },
  methods: {
    // 下拉框出现刷新收款人列表
    handleCaptainVisible(e) {
      if (e) {
        getCollectPageList({ payeeName: '' }).then(res => {
          this.settleList = res.data.records;
        });
      }
    },
    // 模糊搜索收款人列表
    handleCaptainRemoteMethod(query) {
      if (query !== '') {
        this.isLoading = true;
        getCollectPageList({ payeeName: query }).then(res => {
          this.settleList = res.data.records;
          this.isLoading = false;
        });
      } else {
        this.settleList = [];
      }
    },
    async getDriverByBill() {
      await logReport({
        url: '/waybill/v2/getWaybillDriverBank',
        params: { waybillNo: this.settleInfo.waybillNo },
        designation: '运单-司机收款信息-传参',
      });
      const { code, data } = await getWaybillDriverBank({ waybillNo: this.settleInfo.waybillNo });
      if (code === 200) {
        this.driverInfo = data;
      }
      await logReport({
        url: '/waybill/v2/getWaybillDriverBank',
        params: data,
        designation: '运单-司机收款信息-请求结果',
      });
    },
    async handleSelectMethod(method) {
      this.$emit('input', method);
      if (method === 1) {
        //司机
        this.settleInfo.captainName = null;
        this.getDriverByBill();
        this.$emit('change', method, {});
      }
      if (method === 2) {
        //经纪人
        if (this.settleInfo.captainName === '结算给司机') {
          this.settleInfo.captainName = '';
        }
        const { code, data } = await getCollectPageList({ payeeName: '' });
        if (code === 200) {
          this.settleList = data.records;
          if (!this.settleInfo.captainName) {
            this.selectSettle = this.settleList.find(item => {
              return item.isDefault === 1;
            });
          } else {
            this.selectSettle = this.settleList.find(item => {
              return item.id == this.settleInfo.collectInfoId;
            });
          }
          if (this.selectSettle) {
            this.settleInfo.captainName = this.selectSettle.payeeName;
            this.getPayeeName(this.selectSettle);
            this.$emit('change', this.value, this.selectSettle);
          } else {
            this.$emit('change', this.value, {});
          }
        }
      }
    },
    // 当前选中的经纪人
    handleSelectSettle(val) {
      // 当前选中公司
      if (val === 'createSettle') {
        this.settleInfo.captainName = '';
        this.showCaptain = true;
      } else {
        this.selectSettle = this.settleList.find(item => {
          return item.id === val;
        });
        this.settleInfo.captainName = this.selectSettle.payeeName;
        this.getPayeeName(this.selectSettle);
        this.$emit('change', this.value, this.selectSettle);
        this.handleCaptainVisible(true);
      }
    },
    // 自定义选中经纪人展示信息
    getPayeeName({ payeeName, payeeBankCardNo }) {
      this.payeeName = `${payeeName} (${payeeBankCardNo.substring(payeeBankCardNo.length - 4)}）`;
    },
  },
};
</script>
<style lang="scss">
.nf-settle-captain {
  .el-select-dropdown__item {
    height: auto;
    margin-bottom: 10px;
    padding: 0 15px;

    &:first-child {
      margin-bottom: 0;
      height: 40px;
    }
  }

  .nf-settle-captain-option {
    width: 295px;
    height: 72px;
    border-radius: 4px;
    border: 1px solid #eeeeee;
    padding: 10px;
    box-sizing: border-box;

    &_info {
      font-size: 14px;
      color: #666666;
      line-height: 16px;
      margin-bottom: 8px;

      .icon-default {
        float: right;
        width: 30px;
        height: 16px;
        line-height: 16px;
        text-align: center;
        color: #f36807;
        font-size: 10px;
        background: #ffecdf;
        border-radius: 2px;
        border: 1px solid #ffd9bf;
        box-sizing: border-box;
      }
    }

    &_bankName,
    &_payeeBankCardNo {
      font-size: 11px;
      color: #8492a6;
      line-height: 11px;
      margin-bottom: 8px;
    }
  }
  .nf-settle-captain-driver {
    height: 20px;
    line-height: 20px;
    padding: 0px;
    margin: 0;
    margin-top: -5px;
  }
  .nf-settle-captain-option-driver {
    padding-bottom: 0px;
    height: 50px;
    padding: 5px 10px;
  }
}
</style>
